import { SVGProps } from "react";

const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5456_30567)">
      <path
        d="M4.36035 15.2212C4.36035 16.7204 4.65565 18.205 5.22938 19.5901C5.80311 20.9752 6.64404 22.2337 7.70416 23.2939C8.76428 24.354 10.0228 25.1949 11.4079 25.7686C12.7931 26.3424 14.2776 26.6377 15.7768 26.6377C17.2761 26.6377 18.7606 26.3424 20.1457 25.7686C21.5309 25.1949 22.7894 24.354 23.8495 23.2939C24.9096 22.2337 25.7506 20.9752 26.3243 19.5901C26.898 18.205 27.1933 16.7204 27.1933 15.2212C27.1933 12.1933 25.9905 9.28951 23.8495 7.1485C21.7085 5.00749 18.8047 3.80469 15.7768 3.80469C12.749 3.80469 9.84517 5.00749 7.70416 7.1485C5.56316 9.28951 4.36035 12.1933 4.36035 15.2212Z"
        stroke="#ffffff"
        strokeWidth="2.2833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7773 11.4141H15.789"
        stroke="#ffffff"
        strokeWidth="2.2833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5107 15.2188H15.779V20.2919H17.0473"
        stroke="#ffffff"
        strokeWidth="2.2833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5456_30567">
        <rect
          width="30.444"
          height="30.444"
          fill="white"
          transform="translate(0.555664)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default InfoIcon;
